import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { PersonalizationInfo } from 'shared/types/soa/order/orders';
import { Format } from '@/components/customercenter-ui/utils/formatUtils';
import CrossIcon from '@/customercenter-ui/icons/cross';
import PenIcon from '@/customercenter-ui/icons/pen';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

interface PersonalizationProps {
  personalizationInfo: PersonalizationInfo | undefined;
}
const Personalization: React.FC<PersonalizationProps> = ({ personalizationInfo }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const projectSettings: ProjectSettings = useProjSettings();
  const [imageUrl, setImageUrl] = useState<string>('');
  const designId = personalizationInfo?.designId;

  useEffect(() => {
    const isEnabled = projectSettings?.artifiEnabled ?? false;
    const webApiClientKey = projectSettings?.artifiWebApiClientKey;
    const websiteId = projectSettings?.artifiWebsiteId;
    const previewImageURL = projectSettings?.artifiPreviewImageURL;
    if (isEnabled && webApiClientKey && websiteId && designId) {
      setImageUrl(Format(previewImageURL, [websiteId, webApiClientKey, designId]));
    }
  }, [projectSettings, designId]);

  return (
    <section>
      <section>
        <section className="border-radius-[6px] my-3 rounded-md border-[2px] border-foggyGray bg-lightSilver pl-3 pt-3 shadow-md lg:mr-3 lg:pr-2">
          <section className="flex flex-row gap-4">
            <section>
              <PenIcon />
            </section>
            <section className="pb-3 text-base">
              <p>
                <strong>{mapLocaleToMeaningfulFormat().personalization}:</strong>{' '}
                <Link href={''} className="font-bold text-[#0075C9] underline" onClick={() => setShowModal(true)}>
                  {mapLocaleToMeaningfulFormat().view}
                </Link>
              </p>
            </section>
          </section>
        </section>
        {showModal && (
          <section className="fixed inset-0 z-50 flex items-center justify-center">
            <section className="absolute inset-0 bg-black opacity-75" onClick={() => setShowModal(false)}></section>
            <section className="relative z-10 m-4 max-w-lg rounded-md bg-white p-6 lg:m-0">
              <section className="mb-6 flex items-center justify-between">
                <h3 className="text-xl font-bold">{mapLocaleToMeaningfulFormat().personalization}</h3>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowModal(false)}>
                  <CrossIcon />
                </button>
              </section>
              <section className="text-base font-normal leading-6 text-black">
                <img src={imageUrl} alt="peronalizedImage" />
              </section>
            </section>
          </section>
        )}
      </section>
    </section>
  );
};

export default Personalization;
